// ProductType Mutations

export const updateProductTypeList = (state, payload) => {
  state.productTypeList = payload
}

export const fetchProductTypeInfo = (state, payload) => {
  state.productTypeInfo = payload
}

export const updateFullProductTypesList = (state, payload) => {
  state.fullProductTypesList = payload
}
